import {
  AUDIO_EXTENSIONS,
  IMAGE_EXTENSIONS,
  VIDEO_EXTENSIONS,
} from "constants/file_types_extensions";

// convert object to form data
export const convertObjToFormData = (data) => {
  const form = new FormData();
  Object.entries(data).forEach((item) => {
    if (
      !checkEmptyValue(item[item.length - 1]) ||
      item[item.length - 1] instanceof File ||
      typeof item[item.length - 1] === "number"
    ) {
      form.append(...item);
    }
  });

  return form;
};

//check empty value
export const checkEmptyValue = (values) => {
  typeof values === "string" && (values = values.trim());
  return values === undefined || values === null || !values.length;
};

// remove duplicate values from array object
export const convertToUniqueArrayObject = ({
  array,
  key = "id",
  index = "first",
}) => {
  let uniqueObject = [];

  if (index === "first") {
    uniqueObject = array.filter((obj, index) => {
      return index === array.findIndex((o) => obj[key] === o[key]);
    });
  } else {
    uniqueObject = array.filter((obj, index) => {
      return index === array.findLastIndex((o) => obj[key] === o[key]);
    });
  }
  return uniqueObject;
};
 
export const convertUrlToFileName = (file = "", get = "name") => {
  const fileName = file.split("/");
  return fileName[fileName.length - 1];
};

export const getFileType = (fileName, persian = false) => {
  const file_extension = /[.]/.exec(fileName)
  ? /[^.]+$/.exec(fileName)[0]
  : undefined;
  if (!file_extension) return null;

  if (IMAGE_EXTENSIONS.includes(file_extension.toLocaleLowerCase())) {
    return persian ? "عکس" : "Image";
  }

  if (VIDEO_EXTENSIONS.includes(file_extension.toLocaleLowerCase())) {
    return persian ? "ویدئو" : "Video";
  }

  if (AUDIO_EXTENSIONS.includes(file_extension.toLocaleLowerCase())) {
    return persian ? "صدا" : "Audio";
  }

  return persian ? "فایل" : "File";
};
